import React from 'react';
import { Helmet } from 'react-helmet-async'; // ★これと
import styled from 'styled-components';
import img11 from '../../img/11.jpg';
import Access from '../MainContents/Access';
import DocumentRequest from '../MainContents/DocumentRequest';
const Top = styled.div`
  text-align: -webkit-center;
  margin: auto;
  margin-top: 170px;
  width: 90%;
`;

function Schedule() {

  return (
    <Top>
      {/* ★ここからHelmetの記述を追加します */}
      <Helmet>
        <title>土佐塾予備校　高知での実績No.1予備校</title> {/* ←ここに希望するタイトルを設定 */}
        <meta name="description" content="JR高知駅から徒歩5分と最高の交通アクセス！！ 本校は県内唯一の学校法人の予備校です。 公共交通機関の学割制度を利用できるので、経済的に負担も大幅に軽減できます。" />
        {/* 必要であれば、OGPタグなどもここに追加できます */}
        {/* <meta property="og:title" content="TOSAYOBI高等学院" /> */}
        {/* <meta property="og:description" content="高知の通信制高校です。" /> */}
        {/* <meta property="og:url" content="http://localhost:3000/TosayobiHighSchool" /> */}
        {/* <meta property="og:image" content="ここにOGP画像のURL" /> */}
      </Helmet>
      <img src={img11} alt="" />
      <DocumentRequest />
      <Access />
    </Top>
  );
}

export default Schedule;